module.exports = __webpack_public_path__ + "static/media/1_en.74fee7d5.png";